import { render, staticRenderFns } from "./licitacaoItem.vue?vue&type=template&id=99a7933e&scoped=true&"
import script from "./licitacaoItem.ts?vue&type=script&lang=ts&"
export * from "./licitacaoItem.ts?vue&type=script&lang=ts&"
import style0 from "./licitacaoItem.vue?vue&type=style&index=0&id=99a7933e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99a7933e",
  null
  
)

export default component.exports